<template slot="actions">
  <div>
    <NewEditIwlDashboard
      :visible="showNewIwlDialog"
      @close="showNewIwlDialog = false"
    />
    <ValidationObserver ref="search_validation_observer">
      <!-- <form @submit.prevent="getAndUpdateSearchResults" autocomplete="off"> -->
      <v-alert v-if="error" class="errorAlert" transition="scale-transition"
        >{{ error }}
      </v-alert>

      <div class="md-layout" style="align-items: baseline">

        <!-- Search type -->
        <validated-autocomplete-input
          v-model="search.key"
          label="Search by"
          :options="SEARCH_KEYS"
          class="md-layout-item md-size-30"
          force
        />

        <!-- Search input -->
        <validated-text-input
          class="md-layout-item"
          clearable
          :label="'Search ' + search.key"
          v-model="search.query"
          @done="getAndUpdateSearchResults"
        />

        <loading-icon-text-button
          class="md-primary md-layout-item md-size-10 top-navbar-search"
          @click="getAndUpdateSearchResults"
          icon="search"
          :loading="search.status == 'loading'"
          :disabled="application_status.loading || !search.key || !search.query"
        />
        <md-menu style="display: flex; width:50px;" >
          <md-button
            md-menu-trigger
            class="md-icon-button md-primary md-simple new-app-button"
          >
            <md-icon id="new-app-icon">note_add</md-icon>
          </md-button>
          <md-menu-content class="action-menu">
            <md-menu-item v-if="userHasPermission('create loan-application')" @click="startNewApplication">
              <md-icon>edit</md-icon>
              New FIN Application
            </md-menu-item>
            <md-menu-item @click="startNewIwlApplication">
              <md-icon>launch</md-icon>
              New INS Application
            </md-menu-item>
          </md-menu-content>
        </md-menu>
      </div>
      <!-- </form> -->
    </ValidationObserver>
    <div
      class="search-popup-overlay"
      v-if="search.status == 'loaded'"
      v-on:click="closeSearch"
    ></div>
    <div class="search-popup" v-if="search.status == 'loaded'">
      <application-list
        v-if="search.results && search.results.length > 0"
        :items="search.results"
        :loading.sync="loading_status"
        @update="openApplicationEditor"
        @view="openApplicationSummary"
        @update-status="openUpdateStatusDialog"
        @manage-owners="openManageOwnersDialog"
        @attachments="openApplicationDocuments"
        @comment="openCommentDialog"
        @clone="onCloneApplication"
        isSearch
      />
      <md-subheader v-else>No applications found</md-subheader>
    </div>
    <md-subheader v-else-if="search.status == 'failed'"
      >Search failed, please check your search query is correct.
    </md-subheader>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ValidatedInputs from "@/components/ValidatedInput";
import ApplicationList from "@/components/ApplicationList";
import ValidatedSelectInput from "../ValidatedInput/ValidatedSelectInput";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import LoadingIconButton from '@/components/LoadingIconButton';
import WaitingDialog from "@/components/Dialogs/WaitingDialog";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";
import OptionsDialog from "@/components/Dialogs/OptionsDialog";
import NewEditIwlDashboard from "../../pages/NewEditIwlDashboard.vue";

export default {
  watch: {
    //close the search dialogue if the route changes
    $route(to, from) {
      this.closeSearch();
    },
  },
  components: {
    ValidatedSelectInput,
    ...ValidatedInputs,
    ApplicationList,
    LoadingIconTextButton,
    LoadingIconButton,
    ConfirmDialog,
    NewEditIwlDashboard,
  },
  data() {
    return {
      SEARCH_KEYS: ['Id', 'Name', 'Email', 'Phone',],
      error: null,
      loading_status: false,
      search: {
        key: "Email",
        query: "",
        status: "initial",
        results: [],
      },
      transfer_user_search: {
        query: "",
        searching: false,
        users: [],
        show: false,
        application: null,
        selected_user: null,
      },
      cloneConfirm: false,
      cloneApplication: null,
      pusher: null,
      showNewIwlDialog: false,
    };
  },
  computed: {
    ...mapGetters([
      "application_status",
      "userHasPermission",
      "user",
      "system_messages"
    ]),
  },
  methods: {
    async getAndUpdateSearchResults() {
      this.search.status = "loading";

      try{
        let outcome = await this.$store.dispatch("perform_application_search", {
          key: this.search.key,
          query: this.search.query,
        });

        if (outcome) {
          this.loadSearchResult();
          this.search.status = "loaded";
        } else {
          this.search.status = "failed";
        }

      }catch(error){
        console.error('Search request failed');
        console.error(error);
        this.search.status = "failed";
      }
    },
    loadSearchResult() {
      let application_search = this.$store.getters.application_search;
      this.search = {
        ...this.search,
        ...application_search,
      };

      if (this.search.results && this.search.results.length > 0) {
        this.search.status = "loaded";
      }
    },
    async openApplicationSummary(application) {
      this.closeSearch();
      this.$router.push(`/application/${application.id}/summary`);
    },
    async openApplicationEditor(application) {
      this.closeSearch();
      this.$router.push(`/application/${application.id}/capture`);
    },
    async openApplicationDocuments(application) {
        await this.$store.dispatch("load_application", application.id);
        this.$router.push(`/application/${application.id}/documents`);
    },
    openManageOwnersDialog(application) {
      this.$store.commit('set_application_update_owners_dialog', application);
    },
    openUpdateStatusDialog(application) {
      this.$store.commit('set_application_update_status_dialog', application);
    },
    async openCommentDialog(application) {
       await this.$store.dispatch("open_comment_dialog", application);
    },
    closeSearch() {
      this.search.status = null;
      this.loading_status = false;
    },
   async onCloneApplication(application) {
      const cloneApplication = { ...application };
      const response = await this.$modal.show(OptionsDialog,{
        title: this.system_messages?.clone_application?.title,
        message: this.system_messages?.clone_application?.message,
        confirmText: this.system_messages?.clone_application?.confirmText,
        cancelText: this.system_messages?.clone_application?.cancelText,
        options: {
          includeDocs: { label: "Documents", value: true },
          includeComment: { label: "Comments", value: true }
        }
      });

      if (response) {
        this.$modal.show(WaitingDialog, {
          title: this.system_messages?.clone_application?.title,
          message: this.system_messages?.clone_application?.waitingText,
        });

        await this.$store.dispatch("clone_loan_application", {
          application_id: cloneApplication.id,
          includeDocs: response?.options?.includeDocs ?? false,
          includeComment: response?.options?.includeComment ?? false,
        });

        const application =  this.$store.getters.application;

        if (this.$modal.submit) {
            this.$modal.submit();
        }

        this.openApplicationEditor(application.loan);
      }
    },
    startNewApplication() {
      this.$store.dispatch('load_blank_application');
      this.$router.push('/application/new/capture');
    },
    startNewIwlApplication() {
      this.showNewIwlDialog = true;
    },
    async subscribeToLocalLeadPusher() {
      if (this.user.postcode === "" || this.user.postcode == null) {
        // when user does not have post code, do not subscribe to channel.
        return;
      }
      const channelName = `local-lead-auction-channel.${this.user.postcode}`;
      const { channel } = await this.$store.dispatch('subscribe_to_pusher_channel', channelName);
      if (channel === null) {
        return;
      }
      channel.bind("local-lead-auction", (data) => {
        const message = "Local lead available in auction <a href=\"" + data["message"] + "/application/new/tools\" target=\"_blank\">Click here</a>.";
        this.$notifications.notify({
          'message': message,
          'timeout': 300000,
          'verticalAlign': 'top',
          'horizontalAlign': 'center',
          'hardNotification': true
        });
      });
    },
  },
  mounted () {
    // if user is broker and has postcode, they are subscribed to local lead
    if (this.user.primary_roles.includes("Broker") && this.user.postcode !== null) {
      this.subscribeToLocalLeadPusher()
    }
  }

};
</script>


<style scoped>
/*
    Creates a black overlay for the search popup
*/
@media screen and (max-width:1620px) {
  .md-layout-item {
    padding-right: 5px;
    padding-left: 5px;
  }
}

button.md-button.md-icon-button.md-primary.md-simple.new-app-button {
    font-size:12px !important;
    color: #ffffff !important;
    padding: 11px 0;
    margin-left: 10px;
}

.search-popup-overlay {
  opacity: 0.7;
  background: #000;
  width: 100%;
  height: 100%;
  z-index: 10;
  top: 0;
  left: 0;
  position: fixed;
}

/*
    Creates a popup for the search
*/
.search-popup {
  position: absolute;
  background: white;
  border: 1px grey solid;
  margin-top: 2vh;
  z-index: 16;
  right: 10%;
  left: 10%;
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  overflow-x: hidden;
}

.close-button {
  cursor: pointer;
}

.top-navbar-search {
  padding: 0;
}

.top-navbar-search .md-ripple {
    padding: 11px 30px !important;
}

</style>


